/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useCallback, useState } from 'react';
import styles from './ResumeUploader.module.less';
import { CloudUploadOutlined } from '@ant-design/icons';
import { Button, Divider, Typography } from 'antd';
import FileUploadEx from '../FileUpload/FileUpload';
import { ResumeCard } from './ResumeCard';
import { ResumeType } from '../../models/UserModels';
import moment from 'moment';
import Utils from '../../utils/Utils';

const { Text } = Typography;

type Props = {
  value?: ResumeType[];
  onChange?: (value: ResumeType[]) => void;
  title?: string;
  titleText?: string;
};
export const ResumeUploader: FC<Props> = (props) => {
  const [error, seterror] = useState<string>('');
  const [limit, setLimit] = useState<number>(3);
  const [toggled, setToggled] = useState<boolean>(false);

  const handlerChange = useCallback(
    (tog: boolean, url?: string) => {
      if (url) {
        const temp = [...(props.value ?? [])];
        temp.push({ url, time: moment().unix(), status: true });
        props.onChange?.(temp);
        if (!tog) {
          setLimit(3);
        } else {
          setLimit(temp.length);
        }
      }
    },
    [props],
  );
  const handlerRemove = useCallback(
    (time) => {
      const temp = [...(props.value ?? [])];
      const x = temp.filter((v) => v.time !== time);
      props.onChange?.(x);
    },
    [props],
  );

  const handleChekbox = useCallback(async (time, status, data) => {
    if (data?.length !== 0) {
      const temp = [...(data ?? [])];
      temp.forEach((obj) => {
        if (obj.time === time) {
          obj.status = status;
        }
      });
      await props.onChange?.(temp);
    }
  }, []);
  const uploadValidation = useCallback((file) => {
    seterror('');
    const isTypeCheck =
      file.type === 'application/pdf' ||
      file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
      file.type === 'application/msword' ||
      file.type === 'application/rtf' ||
      file.type === 'application/vnd.oasis.opendocument.text' ||
      file.type === 'text/plain';
    if (!isTypeCheck) {
      seterror('Must match file type');
    }
    const isSize = file.size / 1024 / 1024 < 2.5;
    if (!isSize) {
      seterror('Must match file Size');
    }
    return isSize && isTypeCheck;
  }, []);

  return (
    <div className="w-full">
      {props?.titleText && props.value && props.value?.length > 0 ? (
        <div className="mb-2">
          <Text className="text-[14px] text-slate-600">{props.titleText}</Text>
        </div>
      ) : (
        <span className="text-[12px] font-medium">
          {props.value && props.value?.length > 0
            ? `Select which ${
                props.title == 'resumes' ? props.title : 'cover letters'
              } headhunters can view`
            : ''}
        </span>
      )}

      {[...(props.value ?? [])].slice(0, limit).map((value, index) => (
        <>
          <ResumeCard
            type={props.title}
            status={value?.status ?? true}
            onChange={(e) => handleChekbox(value.time, e, props.value)}
            title={value.url.split('/').pop() ?? ''}
            key={index}
            onDelete={() => handlerRemove(value.time)}
            onDownload={() => {
              window.open(value.url, '_blank');
            }}
            text={moment.unix(value.time).format('L')}
          />
          {[...(props.value ?? [])].slice(0, limit).length === index + 1 &&
            [...(props.value ?? [])].length > 3 &&
            props.title && (
              <div
                onClick={() => {
                  if (limit === 3) {
                    setToggled(true);
                    setLimit([...(props.value ?? [])].length);
                  } else {
                    setToggled(false);
                    setLimit(3);
                  }
                }}
                className="text-center flex items-center justify-center">
                {limit === 3 && (
                  <span className="cursor-pointer">
                    Show all {[...(props.value ?? [])].length}{' '}
                    {props.title == 'resumes' ? 'resumes' : 'cover letters'}{' '}
                  </span>
                )}
                {limit !== 3 && <span className="cursor-pointer">Show less</span>}
                <i
                  className={`cursor-pointer icon-chevron-down-1 transform ${
                    limit !== 3 ? 'rotate-180' : 'rotate-0'
                  } text-[26px]`}
                />
              </div>
            )}
        </>
      ))}

      <div className="border-dashed border-2 mt-4 border-slate-300 bg-slate-100 p-4 flex flex-col justify-center items-center w-full min-h-[200px] rounded-lg">
        <FileUploadEx
          onChange={(e) => handlerChange(toggled, e)}
          accept={Utils.CommonDocumentFileFormats}
          acceptSize={2.5}
          beforeUpload={uploadValidation}>
          <div className="h-[280px] flex flex-col justify-center items-center">
            <div className="flex flex-col items-center mt-4">
              <div className="flex justify-center items-center w-[50px] h-[50px] rounded-full bg-slate-200">
                <CloudUploadOutlined className="opacity-50 text-[25px]" />
              </div>
              <Text className="font-semibold">Drag & Drop</Text>
              <Text className="text-[12px] text-slate-500 mb-4">or click to browse files</Text>
              <Button size={'small'} type={'default'} className="!text-[14px] !px-4">
                Browse Files
              </Button>
            </div>
            <Divider />
            <div className="text-center ">
              <Text className="text-[12px] text-slate-500 flex flex-col items-center">
                Accepted Formats: .docx, .doc, .pdf, .txt, .odt or .rtf
              </Text>
              <Text className="text-[12px] text-slate-500">Maximum Size: 2.5 MB</Text>
            </div>
          </div>
        </FileUploadEx>
      </div>
      <div>
        <span className={styles.errorText}>{error}</span>
      </div>
    </div>
  );
};
